import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/newsUtils";
import { AuthShell } from "@/pages/Login";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(email, username, password);
      navigate("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail, "No se pudo crear la cuenta. Inténtalo de nuevo más tarde."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Crear cuenta" subtitle="Empieza a vigilar tus medios en minutos.">
      <form onSubmit={submit} className="space-y-5" data-testid="register-form">
        <div className="space-y-1.5">
          <Label htmlFor="username" className="text-xs uppercase tracking-wide font-semibold">Nombre de usuario</Label>
          <Input id="username" data-testid="register-username" value={username}
            onChange={(e) => setUsername(e.target.value)} required placeholder="¿Cómo te llamamos?"
            className="rounded-none border-border h-11" />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="email" className="text-xs uppercase tracking-wide font-semibold">Correo electrónico</Label>
          <Input id="email" type="email" data-testid="register-email" value={email}
            onChange={(e) => setEmail(e.target.value)} required className="rounded-none border-border h-11" />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="password" className="text-xs uppercase tracking-wide font-semibold">Contraseña</Label>
          <Input id="password" type="password" data-testid="register-password" value={password}
            onChange={(e) => setPassword(e.target.value)} required placeholder="Mínimo 6 caracteres"
            className="rounded-none border-border h-11" />
        </div>
        {error && <p className="text-sm text-destructive" data-testid="register-error">{error}</p>}
        <Button type="submit" data-testid="register-submit" disabled={loading}
          className="rounded-none bg-primary hover:bg-blue-900 w-full h-11 gap-2">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />}
          Crear cuenta
        </Button>
      </form>
      <p className="text-sm text-muted-foreground mt-6">
        ¿Ya tienes cuenta?{" "}
        <Link to="/login" data-testid="go-login" className="text-primary font-semibold hover:underline">
          Inicia sesión
        </Link>
      </p>
    </AuthShell>
  );
}
